export default {
    apiHost: process.env.VUE_APP_APIHOST,
    lbAPiHost: process.env.VUE_APP_LB_APIHOST,
}

const SystemName = process.env.VUE_APP_SYSTEM_NAME || '管理系统'

export {
    SystemName
}